<script lang="ts">
    import { appManager } from "../AppManager";
    import { _ } from "svelte-i18n";
    import { onMount } from "svelte";

    onMount(() => {
        window.location.href = `${appManager.RootUrl}signin`;
    });
</script>